module.exports = __webpack_public_path__ + "static/media/hcc.3be5357f.png";